<template>
  <div class="control-btn-cont">
    <p class="btn-label">{{$t('btns.things.new')}}</p>
    <button type="button" class="btn btn-control circle-btn btn-light-blue">
      <svg width="24" height="30" viewBox="0 0 24 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.9417 8.16671L15.5417 0.733358C15.275 0.466691 14.9417 0.333374 14.6084 0.333374H2.00838C1.27505 0.333374 0.675049 0.933374 0.675049 1.66671V28.3334C0.675049 29.0667 1.27505 29.6667 2.00838 29.6667H22.0084C22.7417 29.6667 23.3417 29.0667 23.3417 28.3334V9.10006C23.3417 8.73339 23.2084 8.40004 22.9417 8.16671ZM20.6751 9.66671H14.0084V3.00004H14.0751L20.6751 9.66671ZM3.34172 27V3.00004H11.3417V10.9667C11.3417 11.7 11.9084 12.3334 12.6417 12.3334H20.6751V27H3.34172Z" fill="#F5F8FA"/>
      </svg>


    </button>
  </div>
</template>

<script>
  export default {
    name: 'addThing'
  }
</script>


